<template>
  <div
    id="app"
    class="main-background"
    v-bind:class="{ dark: getTheme == 'dark' }"
  >
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "ایرانی کار",
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0",
      },
    ],
  },
  mounted() {
    if (this.$route.query.theme == "dark") {
      this.setTheme("dark");
    }
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token);
    }
  },
  methods: mapActions(["setTheme", "setToken"]),
  computed: mapGetters(["getTheme"]),
};
</script>

<style>
</style>
